export function HowItWorks(): JSX.Element {
  return (
    <figure className="w-full">
      <img
        src={`${import.meta.env.BASE_URL}diagram.png`}
        alt="Textbook2Video system diagram"
        loading="lazy"
        className="w-full rounded-lg"
      />
      <figcaption className="mt-4 text-center text-sm text-slate-500">
        High-level overview of the Textbook2Video pipeline.
      </figcaption>
    </figure>
  );
}
